// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Plus from "../Control.Plus/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Homogeneous_Record from "../Data.Homogeneous.Record/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe from "../Unsafe/index.js";
var empty = /* #__PURE__ */ Control_Plus.empty(/* #__PURE__ */ Data_Map_Internal.plusMap(Foliage_Program["_Ord_FixedName"]));
var fromHomogeneous = /* #__PURE__ */ Data_Homogeneous_Record.fromHomogeneous();
var map = /* #__PURE__ */ Data_Functor.map(Data_Homogeneous_Record.functorHomogeneous);
var homogeneous = /* #__PURE__ */ Data_Homogeneous_Record.homogeneous();
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Foliage_Program["_Ord_FixedName"])(Data_Foldable.foldableArray);
var eq = /* #__PURE__ */ Data_Eq.eq(Foliage_Program["_Eq_FixedName"]);
var monadExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.monadExceptT(Data_Identity.monadIdentity);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(monadExceptT));
var throwError = /* #__PURE__ */ Control_Monad_Error_Class.throwError(/* #__PURE__ */ Control_Monad_Except_Trans.monadThrowExceptT(monadExceptT));
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(monadExceptT));
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordInt);
var empty1 = /* #__PURE__ */ Control_Plus.empty(/* #__PURE__ */ Data_Map_Internal.plusMap(Foliage_Program["_Ord_VarName"]));
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Program["_Show_Term"](Foliage_Program["_Eq_Show"]));
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var fromFoldable1 = /* #__PURE__ */ Data_Array.fromFoldable(Data_List_Types.foldableList);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var termUnit = /* #__PURE__ */ (function () {
    return Foliage_Program.UnitTerm.value;
})();
var sumLltr = /* #__PURE__ */ (function () {
    return Foliage_Program.SumLatticeType.create(Foliage_Program.LeftLessThanRight_SumLatticeTypeOrdering.value);
})();
var sumLir = /* #__PURE__ */ (function () {
    return Foliage_Program.SumLatticeType.create(Foliage_Program.LeftIncomparableRight_SumLatticeTypeOrdering.value);
})();
var sumLgtr = /* #__PURE__ */ (function () {
    return Foliage_Program.SumLatticeType.create(Foliage_Program.LeftGreaterThanRight_SumLatticeTypeOrdering.value);
})();
var sumLeqr = /* #__PURE__ */ (function () {
    return Foliage_Program.SumLatticeType.create(Foliage_Program.LeftEqualRight_SumLatticeTypeOrdering.value);
})();
var rules = empty;
var right = /* #__PURE__ */ (function () {
    return Foliage_Program.RightTerm.create;
})();
var relations = empty;
var prod12 = /* #__PURE__ */ (function () {
    return Foliage_Program.ProductLatticeType.create(Foliage_Program.FirstThenSecond_ProductLatticeTypeOrdering.value);
})();
var pair = /* #__PURE__ */ (function () {
    return Foliage_Program.PairTerm.create;
})();
var name = /* #__PURE__ */ fromHomogeneous(/* #__PURE__ */ map(Foliage_Program.FixedName)(/* #__PURE__ */ homogeneous({
    "": "",
    Int: "Int",
    "String": "String",
    "List String": "List String",
    Index: "Index",
    "Symbol": "Symbol",
    joinStrings: "joinStrings"
})));
var ltyUnit = /* #__PURE__ */ (function () {
    return Foliage_Program.UnitLatticeType.value;
})();
var left = /* #__PURE__ */ (function () {
    return Foliage_Program.LeftTerm.create;
})();
var latticeTypeDefs = /* #__PURE__ */ (function () {
    return fromFoldable([ new Data_Tuple.Tuple(name.Int, new Foliage_Program.ExternalLatticeTypeDef({
        name: "Int",
        compare_impl: new Foliage_Common.Opaque(Type_Proxy["Proxy"].value, function (v) {
            if (v.value0 instanceof Foliage_Program.LiteralTerm && (v.value0.value1 instanceof Foliage_Program.NamedDataType && (v.value1 instanceof Foliage_Program.LiteralTerm && (v.value1.value1 instanceof Foliage_Program.NamedDataType && (eq(v.value0.value1.value0)(name.Int) && eq(v.value1.value1.value0)(name.Int)))))) {
                return bind(Data_Maybe.maybe(throwError({
                    label: Foliage_Common["_error"],
                    source: "compare.Int",
                    description: show(v.value0.value0) + " is not an Int"
                }))(pure)(Data_Int.fromString(v.value0.value0)))(function (x1) {
                    return bind(Data_Maybe.maybe(throwError({
                        label: Foliage_Common["_error"],
                        source: "compare.Int",
                        description: show(v.value1.value0) + " is not an Int"
                    }))(pure)(Data_Int.fromString(v.value1.value0)))(function (x2) {
                        return pure(new Data_Tuple.Tuple(compare(x1)(x2), empty1));
                    });
                });
            };
            return throwError({
                label: Foliage_Common["_error"],
                source: "compare.Int",
                description: "inputs are not literal Ints: " + (show1(v.value0) + (", " + show1(v.value1)))
            });
        })
    })), new Data_Tuple.Tuple(name["String"], new Foliage_Program.ExternalLatticeTypeDef({
        name: "String",
        compare_impl: new Foliage_Common.Opaque(Type_Proxy["Proxy"].value, function (v) {
            if (v.value0 instanceof Foliage_Program.LiteralTerm && (v.value0.value1 instanceof Foliage_Program.NamedDataType && (v.value1 instanceof Foliage_Program.LiteralTerm && (v.value1.value1 instanceof Foliage_Program.NamedDataType && (eq(v.value0.value1.value0)(name["String"]) && eq(v.value1.value1.value0)(name["String"])))))) {
                return pure(new Data_Tuple.Tuple(compare1(v.value0.value0)(v.value1.value0), empty1));
            };
            return throwError({
                label: Foliage_Common["_error"],
                source: "compare.String",
                description: "inputs are not literal Strings: " + (show1(v.value0) + (", " + show1(v.value1)))
            });
        })
    })), new Data_Tuple.Tuple(name.Index, new Foliage_Program.LatticeTypeDef(new Foliage_Program.FlatLatticeType(new Foliage_Program.NamedLatticeType(name.Int)))), new Data_Tuple.Tuple(name["Symbol"], new Foliage_Program.LatticeTypeDef(new Foliage_Program.FlatLatticeType(new Foliage_Program.NamedLatticeType(name["String"])))) ]);
})();
var $$function = /* #__PURE__ */ (function () {
    return fromHomogeneous(map(Foliage_Common.Opaque.create(Type_Proxy["Proxy"].value))(homogeneous({
        joinStrings: function (args) {
            return bind1(map1(fromFoldable1)(Unsafe.todo("joinStrings")(lookup("strs")(args))))(function (strs) {
                var $54 = Data_Array.length(strs) <= 2;
                if ($54) {
                    return pure1(new Foliage_Program.LiteralTerm(Data_String_Common.joinWith("")(strs), new Foliage_Program.NamedDataType(name["String"])));
                };
                return pure1(new Foliage_Program.LiteralTerm("[" + (Data_String_Common.joinWith("")(strs) + "]"), new Foliage_Program.NamedDataType(name["String"])));
            });
        }
    })));
})();
var functionDefs = /* #__PURE__ */ (function () {
    return fromFoldable([ new Data_Tuple.Tuple(name.joinStrings, new Foliage_Program.ExternalFunctionDef({
        name: "joinStrings",
        inputs: [ new Data_Tuple.Tuple("strs", new Foliage_Program.NamedDataType(name["List String"])) ],
        output: new Foliage_Program.NamedDataType(name["String"]),
        impl: $$function.joinStrings
    })) ]);
})();
var dataTypeDefs = /* #__PURE__ */ (function () {
    return fromFoldable([ new Data_Tuple.Tuple(name.Int, new Foliage_Program.ExternalDataTypeDef("Int")), new Data_Tuple.Tuple(name["String"], new Foliage_Program.ExternalDataTypeDef("String")), new Data_Tuple.Tuple(name["List String"], new Foliage_Program.ExternalDataTypeDef("List String")) ]);
})();
export {
    name,
    $$function as function,
    dataTypeDefs,
    latticeTypeDefs,
    functionDefs,
    relations,
    rules,
    sumLir,
    sumLgtr,
    sumLltr,
    sumLeqr,
    left,
    right,
    prod12,
    pair,
    ltyUnit,
    termUnit
};
